// Application entrypoint — mounts the React root with router and providers.
import React from 'react'
import ReactDOM from 'react-dom/client'
import { loader } from '@monaco-editor/react'
import '@agion/ui/styles.css'
import App from './App'
import './styles/globals.css'
import './app/i18n'
import { i18nReady } from './app/i18n-init'
import { setupRoutePreloading, preloadCriticalRoutes } from './shared/lib/route-preloader'
import { installPreloadErrorReloadOnWindow } from './shared/lib/preload-error-reload'

// The browser loader uses a CDN version independently of its installed type peer.
// Configure the same verified editor release before any editor can mount.
loader.config({ paths: { vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.57.0/min/vs' } })

// A deploy renames every hashed chunk; tabs opened before it fail their next
// lazy import. Reload once to pick up the current build instead of dropping
// the user into the ErrorBoundary (dev mission designer, 2026-09-11).
installPreloadErrorReloadOnWindow()

async function enableMocking() {
  // Only enable mocking in mock mode
  if (import.meta.env['VITE_USE_MOCK_DATA'] !== 'true') {
    return
  }

  const { worker } = await import('./mocks/browser')

  // Start the worker with onUnhandledFrame: 'bypass' to pass through unhandled requests
  await worker.start({
    onUnhandledFrame: 'bypass',
  })
  console.log('[msw] Mock server started')
}

enableMocking().then(() => {

  i18nReady.then(() => {
    ReactDOM.createRoot(document.getElementById('root')!).render(
      <React.StrictMode>
        <App />
      </React.StrictMode>,
    )

    // Setup automatic route preloading on hover/focus
    setupRoutePreloading()

    // Preload critical routes after initial render
    preloadCriticalRoutes()
  })
})